import React from 'react';

const BlankPage = () => {
  return (
    <div>
      <h2>Blank page</h2>
      <p>...</p>
    </div>
  );
};

export default BlankPage;